import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { FormValue, FormValueState, Group, TypedValue } from '@stylehaven/components';

export function createPermissionInputRequiredValidator(assignableUserGroups: Group[]): ValidatorFn {
    const errorObj: ValidationErrors = { required: true, message: 'form.error.required-field' };

    return (control: AbstractControl): ValidationErrors | null => {
        const controlValue: any = control.value;

        if (controlValue instanceof Array) {
            if (!controlValue.every(value => value instanceof FormValue)) {
                return { required: true, wrongType: true };
            }
            const setValues: FormValue<TypedValue>[] = controlValue.filter(val => val.state === FormValueState.SET);

            const userGroupIds: string[] = assignableUserGroups.map(group => group.Id);

            // At least 1 read and write group that the current user is part of should be set
            const findUserRead = !!setValues.find(
                formValue => formValue.value.type === 'Read' && userGroupIds.includes(formValue.value.value)
            );
            const findUserWrite = !!setValues.find(
                formValue => formValue.value.type === 'Write' && userGroupIds.includes(formValue.value.value)
            );

            if (findUserRead && findUserWrite) {
                return null;
            }
            return errorObj;
        }

        return { required: true, wrongType: true };
    };
}
